import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { useScale } from '../../hooks/useScale';
import { useColors } from '../../hooks/useColors';
import theme from '../../common/theme';

const InputTextStyles = () => {
  const { scale } = useScale();
  const { colors } = useColors();

  return useMemo(
    () =>
      StyleSheet.create({
        inputWrapper: {
          height: scale(44),
          width: '100%',
          alignItems: 'center',
          flexDirection: 'row',
          borderRadius: 6,
        },
        inputContainer: {
          flex: 1,
          width: '100%',
          height: '100%',
          fontSize: scale(14),
          paddingHorizontal: scale(10),
          borderTopRightRadius: 6,
          borderBottomRightRadius: 6,
          outlineStyle: 'none',
          color: colors.text,
        },
        inputTitleText: {
          fontSize: scale(14),
          lineHeight: scale(18),
          marginBottom: scale(6),
          paddingLeft: scale(12),
          color: colors.grey6,
        },
        labelContainer: {
          height: '100%',
          borderRightWidth: 1,
          paddingHorizontal: scale(12),
          backgroundColor: colors.grey1,
          borderRightColor: colors.grey3,
          alignItems: 'center',
          justifyContent: 'center',
          borderTopLeftRadius: 6,
          borderBottomLeftRadius: 6,
          marginRight: 1,
        },
        labelText: {
          fontSize: scale(14),
          color: colors.grey6,
        },
        errorText: {
          paddingTop: scale(6),
          paddingLeft: scale(12),
          color: colors.red,
        },
        accessory: {
          width: scale(42),
          height: scale(42),
          position: 'absolute',
          right: 1,
          bottom: 1,
          alignItems: 'center',
          justifyContent: 'center',
          borderTopRightRadius: theme.radius.s,
          borderBottomRightRadius: theme.radius.s,
        },
        colour: {
          width: 'auto',
          paddingRight: scale(6),
          flexDirection: 'row',
        },
        swatch: {
          width: scale(30),
          height: scale(22),
          marginRight: scale(4),
          borderRadius: theme.radius.s,
          backgroundColor: colors.black,
        },
      }),
    [colors, scale],
  );
};

export default InputTextStyles;
